import { useLocation, useNavigate } from 'react-router-dom';
import { rememberRouteScroll } from './askNavigation';

export const isVideoRoute = (pathname) => /^\/track\/[^/]+\/video\/[^/]+$/.test(pathname);

export const getVideoBackgroundLocation = (location) => {
    if (!isVideoRoute(location.pathname)) return null;
    const background = location.state?.videoBackgroundLocation;
    return background && typeof background.pathname === 'string'
        && background.pathname.startsWith('/') && !background.pathname.startsWith('//')
        && !/[\\?#]/.test(background.pathname) && !isVideoRoute(background.pathname)
        ? background : null;
};

export const useVideoNavigation = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const openVideo = (trackId, videoId, trackInfo, options = {}) => {
        if (!trackId || !/^[A-Za-z0-9_-]{11}$/.test(videoId)) return;
        const background = { ...location, state: { ...location.state, videoToPlay: undefined, resumeVideo: undefined } };
        rememberRouteScroll(background);
        // Episode drawers display a track URL without routing away from their
        // origin. Restore that router entry before pushing, so Back preserves
        // the mounted drawer, its scroll position, and its playback state.
        const historyState = window.history.state;
        window.history.replaceState({
            ...historyState,
            idx: Number.isFinite(historyState?.idx) ? historyState.idx : 0,
            key: location.key,
            usr: background.state,
        }, '',
            `${location.pathname}${location.search}${location.hash}`);
        navigate(`/track/${encodeURIComponent(trackId)}/video/${videoId}`, {
            state: { videoBackgroundLocation: background, videoCanGoBack: true, videoAutoPlay: true, videoTrack: trackInfo,
                videoStartSeconds: options.startSeconds, videoAudioContinuationSeconds: options.audioContinuationSeconds,
                videoContinuationUserId: options.continuationUserId },
        });
    };

    const closeVideo = (trackId) => {
        if (getVideoBackgroundLocation(location) && location.state?.videoCanGoBack) {
            navigate(-1);
        } else {
            navigate(`/track/${encodeURIComponent(trackId)}?autoplay=false`, { replace: true });
        }
    };

    return { openVideo, closeVideo };
};
